define.alias("shared/components/shared/post/secondary/hashtag-suggestions/auto", "settings/components/shared/post/secondary/hashtag-suggestions/auto");